export interface IMasterDataRetailerMatchRule {
  ruleId: number;
  retailerId: number;
  matchPattern: string;
  matchPriority: number;
  sourceColumn: string;
  retailerName: string | null;
}

export class MasterDataRetailerMatchRule {
  private readonly _ruleId: number;
  private readonly _retailerId: number;
  private readonly _matchPattern: string;
  private readonly _matchPriority: number;
  private readonly _sourceColumn: string;
  private readonly _retailerName: string | null;

  constructor(props: IMasterDataRetailerMatchRule) {
    this._ruleId = props.ruleId;
    this._retailerId = props.retailerId;
    this._matchPattern = props.matchPattern;
    this._matchPriority = props.matchPriority;
    this._sourceColumn = props.sourceColumn;
    this._retailerName = props.retailerName;
  }

  get ruleId(): number {
    return this._ruleId;
  }
  get retailerId(): number {
    return this._retailerId;
  }
  get matchPattern(): string {
    return this._matchPattern;
  }
  get matchPriority(): number {
    return this._matchPriority;
  }
  get sourceColumn(): string {
    return this._sourceColumn;
  }
  get retailerName(): string | null {
    return this._retailerName;
  }

  static from(props: IMasterDataRetailerMatchRule): MasterDataRetailerMatchRule {
    return new MasterDataRetailerMatchRule(props);
  }

  static toJSON(
    entity: MasterDataRetailerMatchRule,
  ): IMasterDataRetailerMatchRule {
    return {
      ruleId: entity.ruleId,
      retailerId: entity.retailerId,
      matchPattern: entity.matchPattern,
      matchPriority: entity.matchPriority,
      sourceColumn: entity.sourceColumn,
      retailerName: entity.retailerName,
    };
  }
}
